import {
  PrinterIcon,
  RectangleGroupIcon,
  Square2StackIcon,
} from '@heroicons/react/24/outline';
import clsx from 'clsx';

import { Spinner } from '@/components/ui/spinner';
import { EXPORTING, MARKED_UP_PRINT } from '@/config';

import { ExportDrawingTool, ExportToolProps } from './export-drawing-tool';
import { EstimatingTool, ExportToVendorProps } from './estimating-tool';

export type { ExportFuncType } from './export-drawing-tool';

type PrintToolProps = {
  printing?: boolean;
  printLocal: () => void;
};

const LabelSpinner = ({ sizeClass = 'w-34' }: { sizeClass?: string }) => (
  <div className={clsx('h-30 mx-1', sizeClass)}>
    <Spinner size="sm" className="mt-1 inline-block" />
    <span className=" ml-1 text-xs inline-block text-gray-600 align-bottom">
      {EXPORTING}
    </span>
  </div>
);

export const TakeoffTopTools = ({
  downloading,
  creating,
  printing,
  togglePreview,
  exportTo,
  exportSEV,
  exportInsulation,
  exportPoundage,
  exportPoundageProject,
  exportPipes,
  exportPipesProject,
  outputTo,
  printLocal,
}: {
  togglePreview: boolean;
} & ExportToolProps &
  ExportToVendorProps &
  PrintToolProps) => (
  <>
    {downloading && <LabelSpinner />}
    {!downloading && (
      <ExportDrawingTool
        exportTo={exportTo}
        exportSEV={exportSEV}
        exportInsulation={exportInsulation}
        exportPoundage={exportPoundage}
        exportPoundageProject={exportPoundageProject}
        exportPipes={exportPipes}
        exportPipesProject={exportPipesProject}
      />
    )}
    {/* == For vendor use such as: fast-duct - @2025/08/06 == */}
    {creating && <LabelSpinner />}
    {!creating && <EstimatingTool outputTo={outputTo} />}
    {/* == marked up exporting == */}
    {printing && <LabelSpinner sizeClass="w-38" />}
    {!printing && (
      <button
        type="button"
        className="btn-title-tool mr-2"
        onClick={printLocal}
      >
        <PrinterIcon className="size-4 text-blue-600 inline-block" />
        <span className="text-sm px-1">{MARKED_UP_PRINT}</span>
      </button>
    )}
    <button type="button" className="btn-title-tool mr-2 hidden">
      {togglePreview ? (
        <Square2StackIcon className="size-4 text-blue-600 inline-block" />
      ) : (
        <RectangleGroupIcon className="size-4 text-blue-600 inline-block" />
      )}
      <span className="text-sm px-1">
        {togglePreview ? 'Report' : 'Symbol'} View
      </span>
    </button>
  </>
);
